const DEFAULT = { back: "#C5EBD6", mid: "#B2E3C8", front: "#96D9B4", front2: "#84D1A8", path: "#F6E7C4", edge: "#E8D3A4", tuft: "#5FBF8C" };

export function Meadow({ period, palette = DEFAULT }) {
  const p = palette;
  return (
    <div aria-hidden className="pointer-events-none absolute inset-x-0 bottom-0 h-[58%] overflow-hidden sm:h-[46%]">
      {/* layered hills */}
      <div className="absolute -left-[30%] bottom-0 h-[86%] w-[90%] rounded-[50%]" style={{ background: p.back }} />
      <div className="absolute -right-[28%] bottom-0 h-[78%] w-[92%] rounded-[50%]" style={{ background: p.mid }} />
      <div className="absolute -left-[20%] bottom-[-18%] h-[70%] w-[150%] rounded-[50%]" style={{ background: p.front }} />
      <div className="absolute -right-[24%] bottom-[-30%] h-[64%] w-[130%] rounded-[50%]" style={{ background: p.front2 }} />

      {/* winding path to the horizon */}
      <svg className="absolute inset-x-0 bottom-0 h-[92%] w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path d="M42,100 C36,72 60,58 52,34 Q51,30 53,26 L61,26 Q60,30 61,34 C70,58 52,72 62,100 Z" fill={p.path} />
        <path d="M42,100 C36,72 60,58 52,34 Q51,30 53,26 L61,26 Q60,30 61,34 C70,58 52,72 62,100 Z" fill="none" stroke={p.edge} strokeWidth="0.5" strokeDasharray="2 2" opacity="0.8" />
      </svg>

      {/* grass tufts */}
      {[["7%", "30%"], ["21%", "12%"], ["33%", "38%"], ["69%", "36%"], ["80%", "14%"], ["91%", "32%"]].map(([left, bottom], i) => (
        <svg key={i} viewBox="0 0 24 14" className="absolute h-2.5 w-5 sm:h-3.5 sm:w-7" style={{ left, bottom }}>
          <path d="M4 14 Q5 6 2 3 M9 14 Q10 4 9 1 M14 14 Q14 5 17 2 M19 14 Q20 7 22 5" stroke={p.tuft} strokeWidth="2" strokeLinecap="round" fill="none" />
        </svg>
      ))}

      {/* calm evening tint */}
      {period === "evening" && <div className="absolute inset-0 bg-[#2B2D64]/20" />}
    </div>
  );
}
